import React, { ChangeEvent, VFC } from 'react';
import { Row, Col, Container, useScreenClass } from 'react-grid-system';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useAppInit } from '../../contexts/appInitContext';

import { useOrderContext } from '../../contexts/orderContext';
import { useProductContext } from '../../contexts/productContext';
import { useSettings } from '../../contexts/settingsContext';
import { useTranslation } from '../../contexts/translationContext';
import { tOption, tOrder } from '../../contexts/zod';
import { EASYCOM_ROUTES } from '../../navigation';
import Spacing from '../atoms/Spacing';
import Typography from '../atoms/Typography';

import SearchInput from '../molecules/SearchInput';
import FormikDropdown from './form/FormikDropdown';

import Tabs from './Tabs';

const BorderBottomRow = styled(Row)`
  border-bottom: 1px solid #e0e0e0;
`;

const SectionHeader: VFC<tOrder> = () => {
  const { customerOrderNumbers, defaultOrder, getOrder } = useOrderContext();
  const { searchInputHandler, loading, search } = useProductContext();
  const { params } = useAppInit();
  const { customerNumber, email } = params;
  const location = useLocation();
  const screenClass = useScreenClass();
  const { productSearchEnabled } = useSettings();
  const onChange = async (option: tOption) => {
    await getOrder({ email, customerNumber, orderNumbers: [option.value] });
  };
  const { translate } = useTranslation();
  const translatedPlaceholder = translate('placeholder_search', null);

  const getRightSearchOptions = () => {
    const path = location.pathname;
    switch (path) {
      case EASYCOM_ROUTES.PRODUCT_PAGE:
        return (
          <SearchInput
            value={search}
            placeholder="search_product"
            disabled={loading}
            icon="search"
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              searchInputHandler(e.target.value)
            }
          />
        );
      default:
        return (
          <FormikDropdown
            onChange={onChange}
            options={customerOrderNumbers}
            error={undefined}
            translateKey={undefined}
            className={undefined}
            name={undefined}
            updateValue={false}
            placeholder={translatedPlaceholder}
          />
        );
    }
  };

  const shouldScale = ['lg', 'xl', 'xxl'].includes(screenClass);

  return (
    <Container>
      <Spacing spacing={shouldScale ? 6 : 3} />

      <Row justify="center">
        <Typography
          translateKey="create_returns"
          align="center"
          variant={shouldScale ? 'h3' : 'h3'}
        />
      </Row>
      {productSearchEnabled && (
        <>
          <Spacing spacing={2} />
          <BorderBottomRow justify="center">
            <Tabs />
          </BorderBottomRow>
        </>
      )}
      <Spacing spacing={3} />
      <BorderBottomRow justify="center">
        <Col sm={12} md={6} lg={4}>
          {getRightSearchOptions()}
          <Spacing spacing={4} />
        </Col>
      </BorderBottomRow>
    </Container>
  );
};

export default SectionHeader;
